import { cn } from '../cn.js';

export interface SpinnerProps {
  size?: number;
  className?: string;
}

/** An indeterminate loading spinner that inherits `currentColor`. */
export function Spinner({ size = 20, className }: SpinnerProps): JSX.Element {
  return (
    <span
      className={cn('as-spinner', className)}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    />
  );
}
